module.exports = __webpack_public_path__ + "img/scope3category9.8ed6687d.svg";